import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { Button } from 'ui-components/components/button';
import ModalPortal from '../../../../components/modal-portal';
import { useProductContext } from '../../products/product-context';
import AutoSplitModal from '../modals/autosplit/autosplit-modal';

import messages from '../../messages';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';

export const AutoSplitButton = () => {
  const { selectedProductIds } = useProductContext();
  const [isAutoSplitModalOpen, setAutoSplitModalOpen] = useAsyncSafeState(false);

  const openAutoSplitModal = () => setAutoSplitModalOpen(true);
  const closeAutoSplitModal = () => setAutoSplitModalOpen(false);

  return (
    <>
      <Button className={style['reusable-button']} disabled={selectedProductIds.length < 1} onClick={openAutoSplitModal} theme='tertiary'>
        <FormattedMessage {...messages.autoSplitButton} />
      </Button>
      {isAutoSplitModalOpen && (
        <ModalPortal onClose={closeAutoSplitModal}>
          <AutoSplitModal onClose={closeAutoSplitModal} />
        </ModalPortal>
      )}
    </>
  );
};
